<template>
  <v-layout
    align-center
    justify-center
    align-content-center
    style="z-index:10000"
  >
    <modal
      name="successModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Success</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        This process can take up to 24 hours to complete.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('successModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <modal
      name="successDisabledModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Success</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        User has been disabled.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('successModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <modal
      name="errorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Something went wrong. Please try again. If the error persists, please
        contact support.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('errorModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <modal
      name="usernameErrorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
      style="z-index:10000;"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        {{ usernameErrorText }}
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#00558C"
          dark
          @click="
            $modal.hide('usernameErrorModal');
            $modal.show('editModal');
          "
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <modal
      name="editModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
      ><v-progress-circular
        indeterminate
        color="green"
        v-if="wait"
        size="50"
        class="waitCircle"
      ></v-progress-circular>
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Add/Edit True Writing Agent</v-toolbar-title>
      </v-toolbar>
      <v-text-field
        ref="Name"
        v-model="editingItem.Name"
        label="Agent Name"
        disabled
        outlined
        required
        dense
        style="padding-left: .5em; padding-right: .5em;"
      ></v-text-field>
      <v-text-field
        ref="agentNum"
        v-model="editingItem.AgentNum"
        label="Agent Number"
        disabled
        outlined
        required
        dense
        style="padding-left: .5em; padding-right: .5em;"
      ></v-text-field>
      <v-text-field
        ref="email"
        data-test="email"
        v-model="editingItem.Email"
        :rules="[
          () => !!editingItem.Email || 'E-mail is required.',
          () =>
            /^([a-zA-Z0-9_+-]+\.?)+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]{1}[a-zA-Z0-9-.]+$/.test(
              editingItem.Email ? editingItem.Email.trim() : editingItem.Email
            ) || 'E-mail must be valid'
        ]"
        label="Email"
        outlined
        required
        dense
        :disabled="wait"
        style="padding-left: .5em; padding-right: .5em;"
      ></v-text-field>
      <v-text-field
        ref="status"
        v-model="editingItem.AccessStatusDescription"
        label="Status"
        outlined
        disabled
        dense
        style="padding-left: .5em; padding-right: .5em;"
      ></v-text-field>
      <v-checkbox
        color="green"
        ref="enabled"
        v-model="editingItem.Checked"
        :label="editingItem.AccessLabel"
        style="padding-bottom: 0px; margin-bottom: 0px; margin-top: unset; padding-left: .5em; padding-right: .5em;"
        :disabled="wait"
      ></v-checkbox>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" :disabled="wait" dark @click="saveAgent()"
          >Save</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="#00558C"
          :disabled="wait"
          dark
          @click="$modal.hide('editModal')"
          >Cancel</v-btn
        >
      </v-card-actions>
    </modal>

    <div :class="$vuetify.breakpoint.smAndUp ? 'drop page-spacer' : 'drop'">
      <span v-if="$vuetify.breakpoint.xs">
        <v-layout justify-center align-content-center align-center column>
          <v-icon color="green" size="100">mdi-account</v-icon>
          <v-layout justify-center align-content-center align-center column>
            <v-card-title
              style="color: #00558c; font-weight: bold; text-align: center"
              >True Writing User Management</v-card-title
            >
            <v-card-subtitle style="text-align: center"
              >Modify True Writing Users.</v-card-subtitle
            >
          </v-layout>
        </v-layout> </span
      ><span v-else>
        <v-layout justify-center align-content-center align-center row>
          <v-icon color="green" size="100">mdi-account</v-icon>
          <span>
            <v-card-title
              style="color: #00558c; font-weight: bold; text-align: center"
              >True Writing User Management</v-card-title
            >
            <v-card-subtitle>Modify True Writing Users.</v-card-subtitle>
          </span>
        </v-layout>
      </span>
      <br /><br /><br />
      <!-- 
      <v-layout justify-center align-content-center align-center>
        <v-card-text>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            style="margin-left: 40px"
          ></v-text-field>
        </v-card-text>
      </v-layout> -->
      <v-data-table
        :headers="headers"
        dense
        :items="waitCircle ? [] : sortedUsers"
        :no-data-text="
          waitCircle ? 'Please wait...' : 'No True Writing Users Found.'
        "
        item-key="UniqueAgentID"
        class="elevation-4"
        :loading="waitCircle"
        :sort-desc="true"
        mobile-breakpoint="960"
      >
        <template v-slot:[`item.Name`]="{ item }">
          {{ item.Name }}
        </template>

        <template v-slot:[`item.AgentNum`]="{ item }">
          {{ item.AgentNum }}
        </template>

        <template v-slot:[`item.Email`]="{ item }">
          {{ item.Email }}
        </template>

        <template v-slot:[`item.Status`]="{ item }">
          {{ item.Status }}
        </template>

        <template v-slot:[`item.edit`]="{ item }">
          <v-tooltip top color="green" dark>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" @click="editItem(item)">mdi-lead-pencil</v-icon>
            </template>
            <span>Edit</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-progress-circular
        indeterminate
        color="green"
        v-if="waitCircle"
        size="50"
        class="waitCircle"
      ></v-progress-circular>
      <br />
      <br />
      <!-- <v-btn
          color="green"
          class="menuBtn"
          dark
          @click="$router.push('/')"
          style="margin-right: 10px"
          >Return to Main Menu</v-btn
        > -->
      <span v-if="$vuetify.breakpoint.xs">
        <v-layout column align-center align-content-center>
          <v-btn
            width="200"
            color="green"
            dark
            class="menuBtn"
            @click.stop="refresh"
            >Refresh</v-btn
          >
          <br /><br /><br /><br /><br />
        </v-layout> </span
      ><span v-else>
        <v-layout justify-end align-content-end align-end>
          <v-btn color="green" dark class="menuBtn" @click.stop="refresh"
            >Refresh</v-btn
          >
        </v-layout>
        <br /><br /><br /><br /><br /><br />
      </span>
    </div>
  </v-layout>
</template>
<script>
import EventBus from "@/eventBus.js";
import utilityMixins from "@/utility-mixins.js";
import { HTTP_GAP } from "@/http-common.js";
// import { HTTP_USER } from "@/http-common.js";

export default {
  mixins: [utilityMixins],
  computed: {
    modalWidth() {
      return this.$vuetify.breakpoint.xs ? "300" : "450";
    },
    modalHeight() {
      return this.$vuetify.breakpoint.xs ? "225" : "450";
    },
    usersFiltered() {
      if (this.hide) {
        return this.users.filter(au => au.AgentAdminStatusCode != "F");
      }

      return this.users;
    },
    calcWidth() {
      return window.innerWidth - 200;
    },
    tmkClientId() {
      return window.sessionStorage.getItem("tmkClientId");
    },
    sortedUsers() {
      function compare(a, b) {
        if (a.LastName < b.LastName) {
          return -1;
        }
        if (a.LastName > b.LastName) {
          return 1;
        }
        return 0;
      }
      var u = this.users.slice();
      u = [...new Map(u.map(o => [o["UniqueAgentID"], o])).values()];
      return u.sort(compare);
    }
  },
  created() {
    if (
      this.tmkClientId == null ||
      this.tmkClientId == undefined ||
      this.tmkClientId == ""
    ) {
      this.$router.push("/unauthenticated");
    } else {
      this.makeAxiosCall();
      this.isMobileCheck();
      window.addEventListener("resize", this.isMobileCheck);
    }
  },
  mounted() {
    EventBus.$on(
      "closeCreateUser",
      function() {
        this.dialog = false;
      }.bind(this)
    );
  },
  beforeDestroy() {
    EventBus.$off("closeCreateUser");
    EventBus.$off("userChange");
  },
  data() {
    return {
      hide: false,
      search: null,
      dialog: false,
      waitCircle: false,
      wait: false,
      editingItem: {},
      status: "",
      email: "",
      users: [],
      usernameErrorText: "",
      headers: [
        {
          text: "Name",
          value: "Name",
          sortable: true
        },

        { text: "Agent Number", value: "AgentNum", sortable: true },

        { text: "UserID", value: "FederationID", sortable: true },

        { text: "Status", value: "Status", sortable: false },

        { text: "Edit", value: "edit", sortable: false }
      ]
    };
  },
  methods: {
    async makeAxiosCall() {
      await this.refresh();
    },
    async refresh() {
      if (
        !window.sessionStorage.getItem("tmkClientId") ||
        window.sessionStorage.getItem("tmkClientId") == ""
      ) {
        return false;
      }

      this.waitCircle = true;
      this.users = [];
      try {
        const results = await HTTP_GAP.get("ReadAgentTrueWriting", {
          params: {
            TMKClientID: window.sessionStorage.getItem("tmkClientId")
          }
        });
        if (results.status == 200) {
          if (results.data.length == 0) {
            return this.$router.push("/usermanagement");
          }
          results.data.map(u => {
            u.Name =
              u.FirstName +
              (u.MiddleName ? " " + u.MiddleName : "") +
              " " +
              u.LastName;
            u.Email = u.FederationID;
            if (
              u.TrueWritingStatus == undefined ||
              u.TrueWritingStatus == "" ||
              u.TrueWritingStatus == null
            ) {
              u.TrueWritingStatus = u.AccessStatusDescription;
            }
            if (
              u.TrueWritingFederationID == undefined ||
              u.TrueWritingFederationID == "" ||
              u.TrueWritingFederationID == null
            ) {
              u.TrueWritingFederationID = u.FederationID;
            }
            u.Status =
              u.TrueWritingStatus == u.AccessStatusDescription &&
              u.TrueWritingFederationID == u.FederationID
                ? u.AccessStatusDescription
                : "Pending";
          });
          this.users = this.users.concat(results.data);
        } else {
          this.$modal.show("errorModal");
        }
        this.waitCircle = false;
      } catch (e) {
        this.waitCircle = false;
        this.$modal.show("errorModal");

        this.addToErrorLogs("TrueWriting.vue refresh ReadAgentTrueWriting", e);
      }
    },
    editItem(item) {
      this.$modal.show("editModal");
      this.wait = true;
      this.editingItem = {};
      this.editingItem = item;
      this.editingItem.Email = item.FederationID;
      this.editingItem.OriginalUserName = item.FederationID;
      HTTP_GAP.get("ReadTrueWritingIndividual", {
        params: {
          UniqueAgentID: item.UniqueAgentID,
          AssociatedAgentTMKClientID: this.tmkClientId
        }
      })
        .then(results => {
          if (results.status == 200) {
            if (results.data.some(() => true)) {
              this.editingItem.Email = results.data[0].FederationID;
              this.editingItem.Enabled =
                results.data[0].AccessStatusDescription == "Enabled";
              this.editingItem.AccessStatusDescription =
                results.data[0].AccessStatusDescription;
              if (results.data[0].Pending) {
                this.editingItem.AccessStatusDescription = "Pending";
              }
            } else {
              this.editingItem.Enabled =
                this.editingItem.AccessStatusDescription == "Enabled";
            }
            this.editingItem.AccessLabel = this.editingItem.Enabled
              ? "Disable Agent Access?"
              : "Enable Agent Access?";
            this.editingItem.Checked = false;
            this.wait = false;
          } else {
            this.waitCircle = false;
            this.$modal.hide("editModal");
            this.$modal.show("errorModal");
          }
        })
        .catch(e => {
          this.wait = false;
          this.$modal.hide("editModal");
          console.log(e);
        });
    },
    saveAgent() {
      if (!this.$refs["email"].validate(true)) {
        this.usernameErrorText = "E-mail must be valid.";
        this.$modal.show("usernameErrorModal");
        return;
      }
      this.wait = true;
      if (this.editingItem.Enabled) {
        this.editingItem.Enabled = !this.editingItem.Checked;
      } else {
        this.editingItem.Enabled = this.editingItem.Checked;
      }
      if (!this.editingItem.Enabled) {
        this.editingItem.AccessStatusDescription = "Disabled";
      } else {
        this.editingItem.AccessStatusDescription = "Enabled";
      }
      var item = {
        UserInfo: {
          TMKClientID: this.editingItem.TMKClientID,
          UserNameCurrent:
            this.editingItem.OriginalUserName ?? this.editingItem.Email,
          UserNameNew: this.editingItem.Email
        }
      };
      HTTP_GAP.put("AMTUpdateUser", item)
        .then(r => {
          if (r.statusCode != 200 && r.status != 200) {
            this.wait = false;
            this.$modal.hide("editModal");
            this.usernameErrorText =
              "Username already exists. Please change the email/username and try again.";
            this.$modal.show("usernameErrorModal");
            return;
          }
          var date = new Date();
          this.editingItem.ManagerTMKClientID = this.tmkClientId;
          this.editingItem.CreatedDate = date;
          this.editingItem.UpdatedDate = date;
          this.editingItem.StartDate = date;
          this.editingItem.EndDate = new Date(
            Date.UTC(2999, 11, 31, 23, 59, 59)
          );
          this.editingItem.CreatedBy = "AMT-" + this.tmkClientId;
          this.editingItem.UpdatedBy = "AMT-" + this.tmkClientId;
          HTTP_GAP.post("CreateAgentTrueWriting", this.editingItem)
            .then(results => {
              if (results.status == 200) {
                this.$modal.hide("editModal");
                this.$modal.show("successModal");
                this.wait = false;
              }
            })
            .catch(e => {
              console.log(e);
              this.wait = false;
              this.$modal.hide("editModal");
              this.$modal.show("errorModal");
              this.addToErrorLogs(
                "TrueWriting.vue submit CreateAgentTrueWriting 1",
                e
              );
            });
        })
        .catch(e => {
          console.log(e);
          if (e == "Request failed with status code 400") {
            this.usernameErrorText =
              "Username already exists. Please change the email/username and try again.";
          } else {
            this.usernameErrorText =
              "An error occurred trying to update the username/email. Please try again. If the error persists, please contact support.";
          }
          this.$modal.hide("editModal");
          this.wait = false;

          this.$modal.show("usernameErrorModal");
          this.addToErrorLogs("TrueWriting.vue submit UpdateUser", e);
        });
    }
  }
};
</script>
<style scoped>
.drop {
  margin-top: 75px;
  position: relative;
  overflow: hidden;
  min-height: 700px;
}
.page-spacer {
  margin-left: 50px;
  margin-right: 50px;
}
.waitCircle {
  z-index: 50;
  position: absolute;
  top: 25%;
  left: 47%;
}
</style>
<style>
.v-data-table-header-mobile__wrapper {
  margin-left: 50px;
}
.btn-spacer {
  margin-left: 10px;
}
</style>
